import { Record, List } from 'immutable';

import BaseStore from './BaseStore';
import { ActionTypes } from '../constants/AppConstants';
import { getProp } from '../helpers/Immutable';

const State = new Record({
    seatingAvailability: new List(),
    showSeatfinder: false,
});

class SeatingStore extends BaseStore {

    getInitialState () {
        return new State();
    }

    setSeatingAvailability ({ seatingAvailability }) {
        const existing = this.state.get('seatingAvailability');
        const newTsids = new Set(seatingAvailability.map(item => item.tsid).filter(Boolean));
        const kept = existing.filter(item => {
            const tsid = getProp(item, 'tsid');
            return tsid && !newTsids.has(tsid);
        });
        this.setState(this.state.set('seatingAvailability', kept.concat(new List(seatingAvailability))));
    }

    getSeatingAvailability () {
        return this.state.get('seatingAvailability');
    }

    toggleSeatfinder () {
        this.setState(this.state.set('showSeatfinder', !this.state.get('showSeatfinder')));
    }

    getSeatfinderStatus () {
        return this.state.get('showSeatfinder');
    }

    getActionHandlers () {
        return {
            [ActionTypes.SEATING_AVAILABILITY_LOADED]: this.setSeatingAvailability,
            [ActionTypes.TOGGLE_SEATFINDER]: this.toggleSeatfinder,
        };
    }
}

const instance = new SeatingStore({ storageKey: 'seating' });



export default instance;
